import React from 'react';
import ErrorContainer from '@src/containers/Error';

const Error = () => <ErrorContainer />;

export default Error;
